import React from 'react';
import Input from './Common/input';
import { Link } from 'react-router-dom';

const CheckoutForm = ({
  data,
  errors,
  handleChange,
  handleSubmit,
  movingToPay,
}) => {
  return (
    <div className='payment-block'>
      <br />
      <h4>Contact information</h4>

      <div className='checkout-user'>
        <div
          className='checkout-user-pic'
          style={{ backgroundImage: 'url(' + data.profilePic + ')' }}
        ></div>
        <div className='checkout-user-info'>
          <h6>
            {data.name} ({data.email})
          </h6>
          <Link to='/logout'>
            <h6>
              <span>Logout</span>
            </h6>
          </Link>
        </div>
      </div>

      <div className='linee'></div>

      <h4>Shipping address</h4>

      <form onSubmit={handleSubmit}>
        <label htmlFor=''>Full Name</label>
        <Input
          type='text'
          placeholder='Name'
          name='name'
          value={data.name}
          onChange={handleChange}
          error={errors.name}
        />

        <label htmlFor=''>Complete address</label>
        <Input
          type='text'
          placeholder='Complete Address'
          name='address'
          value={data.address || ''}
          onChange={handleChange}
          error={errors.address}
        />

        <label htmlFor=''>City</label>
        <Input
          type='text'
          placeholder='City'
          name='city'
          value={data.city || ''}
          onChange={handleChange}
          error={errors.city}
        />
        <div style={{ width: '58%', display: 'inline-block' }}>
          <label htmlFor=''>Country</label>
          <Input
            type='text'
            placeholder='Country'
            disabled
            name='country'
            value={data.country || ''}
            onChange={handleChange}
            error={errors.country}
          />
        </div>

        <div
          style={{ width: '40%', display: 'inline-block', marginLeft: '2%' }}
        >
          <label htmlFor=''>Postal code</label>
          <Input
            type='text'
            placeholder='Postal code'
            name='postalCode'
            value={data.postalCode || ''}
            onChange={handleChange}
            error={errors.postalCode}
          />
        </div>

        <label htmlFor=''>Phone Number</label>
        <Input
          type='text'
          placeholder='Phone Number'
          name='phone'
          value={data.phone || ''}
          onChange={handleChange}
          error={errors.phone}
        />

        <div className='checkout-left-block-btns'>
          <Link to='/products'>
            <button className='checkout-back-btn'>
              <i className='fas fa-angle-double-left'></i> Return to shop
            </button>
          </Link>

          <button disabled={movingToPay} className='continue-to-shipping'>
            Continue to payment {movingToPay && <i className='fas fa-circle-notch'></i>}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CheckoutForm;
